import {HTTP_METHODS} from '../httpMethods'

export const UPLOAD_IMAGES_CONFIG = {
  UPLOAD_IMAGES: () => ({
    endPoint: `image/upload`,
    method: HTTP_METHODS.POST,
    headers: {scope: 'pepsi'},
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
    contentType: 'multipart/form-data',
    multipart: 'multipart',
  }),
}
